/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
// tslint:disable-next-line: no-duplicate-imports
import { IActionContext } from '@msdyn365-commerce/core';
import { CacheType, ZipCodeInfo } from '@msdyn365-commerce/retail-proxy';
import { getAddressFromZipCodeAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/StoreOperationsDataActions.g';

/**
 * GetEyebrowMessage Input Action
 */

export class GetAddressByZipcodeInput implements Msdyn365.IActionInput {
    //   Construct the input needed to run the action
    public country: string;
    public zipcode: string;

    constructor(country: string, zipcode: string) {
        this.country = country;
        this.zipcode = zipcode;
    }

    //   Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `Get-Address-By-Zipcode-${this.zipcode}`;
    public getCacheObjectType = () => 'GetAddressByZipCode';
    public dataCacheType = (): CacheType => 'application';
}

//   Create a data model here or import one to capture the response of the action

/**
 *   Use this function to create the input required to make the action call
 */

/**
 *   Use this function to call your action and process the results as needed
 */
async function getAddressByZipcodeAction(input: GetAddressByZipcodeInput, ctx: IActionContext): Promise<ZipCodeInfo[] | null> {
    const { zipcode, country } = input;
    const isValidZipcode = typeof zipcode === 'string' && zipcode?.trim()?.length === 5 && zipcode !== "00000";
    return isValidZipcode ? getAddressFromZipCodeAsync({ callerContext: ctx, queryResultSettings: { Paging: { Top: 1 } } }, country, zipcode) : null;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ZipCodeInfo[] | null>>getAddressByZipcodeAction,
    //   Give your data action a unique id
    id: 'GetAddressByZipcode'
    //   Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
